import ReactDOMServer from 'react-dom/server';
const getSvgPath = (icon) => {
    const iconString = ReactDOMServer.renderToString(icon);
    const parser = new DOMParser();
    const svgDoc = parser.parseFromString(iconString, 'image/svg+xml');
    const paths = svgDoc.querySelectorAll('path');
    if (!paths.length) {
        return '';
    }
    return Array.from(paths)
        .map((p) => p.getAttribute('d'))
        .filter((d) => !!d && d.length > 0)
        .map((d) => d.replace(/,/g, ' '))
        .join(' ');
};
export { getSvgPath };
